import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fMono, fBody, LogoMark, Wordmark, TRADING_MENU, RESOURCES_MENU, COMPANY_MENU, NavDropdown } from '../../Shared/Brand'

const HERO_VIDEOS = {
  desktop: '/assets/video/hero-desktop.webm',
  tablet: '/assets/video/hero-tablet.webm',
  mobile: '/assets/video/hero-mobile.webm',
}

function getHeroTier(width) {
  if (width < 600) return 'mobile'
  if (width < 1024) return 'tablet'
  return 'desktop'
}

const styles = `
.xp2 { font-family: ${fBody}; }
.xp2 a { color: inherit; text-decoration: none; }
#xp2-top, #xp2-trading, #xp2-resources, #xp2-partner, #xp2-company { scroll-margin-top: 70px; }

@keyframes xp2Ticker { from { transform: translateX(0); } to { transform: translateX(-50%); } }
@keyframes xp2Pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }
@keyframes xp2FadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }

.xp2-ticker-track { animation: xp2Ticker 90s linear infinite; will-change: transform; }
.xp2-partner-track { animation: xp2Ticker 60s linear infinite; will-change: transform; }
.xp2-hero-content { animation: xp2FadeUp 0.9s ease both; }
.xp2-live-dot { animation: xp2Pulse 1.5s infinite; }

.xp2-navlink:hover, .xp2-footerlink:hover { color: ${C.ltx}; }
.xp2-social:hover { color: ${C.ltx}; border-color: ${C.primary}; background: rgba(247,147,26,0.12); }
.xp2-cta:hover { background: ${C.primaryDark}; }
.xp2-tab:hover { color: ${C.ltx2}; }
.xp2-linklike:hover { gap: 10px; }
.xp2-service-card:hover { transform: translateY(-4px); }

@media (max-width: 900px) {
  .xp2-navlinks { display: none !important; }
  .xp2-nav-inner { padding: 0 16px !important; gap: 12px !important; }
  .xp2-grid-why { grid-template-columns: 1fr !important; }
  .xp2-grid-eco { grid-template-columns: 1fr !important; }
  .xp2-grid-eco-phone { order: -1; margin-bottom: 24px; }
  .xp2-grid-stats3 { grid-template-columns: 1fr !important; row-gap: 24px !important; }
  .xp2-grid-stats3 .xp2-divider { display: none; }
  .xp2-footer-top { grid-template-columns: 1fr !important; gap: 32px !important; }
  .xp2-footer-bottom { grid-template-columns: 1fr !important; gap: 32px !important; }
}
@media (max-width: 600px) {
  .xp2-hero-title { font-size: 32px !important; }
  .xp2-why-card1 { grid-column: 1 / -1; }
  .xp2-service-grid { grid-template-columns: 1fr !important; }
  .xp2-hero { min-height: 64vh !important; }
  .xp2-hero-video { object-fit: contain !important; }
  .xp2-tabs-desktop { display: none !important; }
  .xp2-tabs-mobile { display: block !important; }
}
.xp2-tabs-mobile { display: none; }
`

const NAV_LINKS = [
  { label: 'Home', href: '#xp2-top' },
  { label: 'Trading', href: '/trading' },
  { label: 'Resources', href: '/resources' },
  { label: 'Company', href: '/company' },
]

const CATEGORY_TABS = ['Popular', 'BTC Pairs', 'ETH Pairs', 'DeFi', 'Stablecoins', 'Indices']

const CATEGORY_PAIRS = {
  'BTC Pairs': ['BTC/USDT'],
  'ETH Pairs': ['ETH/USDT'],
  DeFi: ['LINK/USDT', 'AVAX/USDT'],
  Stablecoins: ['USDC/USDT'],
  Indices: ['BTC/USDT', 'ETH/USDT', 'BNB/USDT'],
}

const MARKET_PAIRS = [
  { pair: 'BTC/USDT', price: '67,284.50', pct: '2.34', up: true, volume: '$1.82B' },
  { pair: 'ETH/USDT', price: '3,421.80', pct: '1.18', up: true, volume: '$742M' },
  { pair: 'SOL/USDT', price: '148.32', pct: '0.62', up: false, volume: '$318M' },
  { pair: 'BNB/USDT', price: '567.40', pct: '0.87', up: true, volume: '$210M' },
  { pair: 'XRP/USDT', price: '0.622', pct: '1.20', up: false, volume: '$390M' },
  { pair: 'ADA/USDT', price: '0.447', pct: '0.45', up: true, volume: '$145M' },
  { pair: 'AVAX/USDT', price: '28.14', pct: '3.11', up: true, volume: '$98M' },
  { pair: 'LINK/USDT', price: '13.22', pct: '0.38', up: false, volume: '$76M' },
  { pair: 'USDC/USDT', price: '1.000', pct: '0.01', up: true, volume: '$412M' },
]

const BINANCE_SYMBOLS = [
  ['BTCUSDT', 'BTC/USDT'],
  ['ETHUSDT', 'ETH/USDT'],
  ['SOLUSDT', 'SOL/USDT'],
  ['BNBUSDT', 'BNB/USDT'],
  ['XRPUSDT', 'XRP/USDT'],
  ['ADAUSDT', 'ADA/USDT'],
  ['AVAXUSDT', 'AVAX/USDT'],
  ['LINKUSDT', 'LINK/USDT'],
  ['USDCUSDT', 'USDC/USDT'],
]

function formatPrice(n) {
  const v = Number(n)
  if (!isFinite(v)) return '—'
  const decimals = v >= 100 ? 2 : v >= 1 ? 3 : 4
  return v.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
}

function formatVolume(n) {
  const v = Number(n)
  if (!isFinite(v)) return '—'
  if (v >= 1e9) return '$' + (v / 1e9).toFixed(2) + 'B'
  if (v >= 1e6) return '$' + (v / 1e6).toFixed(1) + 'M'
  if (v >= 1e3) return '$' + (v / 1e3).toFixed(1) + 'K'
  return '$' + v.toFixed(0)
}

const PARTNERS = ['BINANCE', 'COINBASE', 'KRAKEN', 'OKX', 'BYBIT', 'KUCOIN', 'TRADINGVIEW', 'DERIBIT', 'GATE.IO', 'BITGET']

const ECOSYSTEM_LEFT = [
  {
    title: 'AI-Powered Arbitrage Engine',
    desc: 'Proprietary AI scans 50+ exchanges simultaneously, detecting profitable spreads before they vanish.',
    icon: <><circle cx="10" cy="10" r="7" stroke={C.tx} strokeWidth="1.4" fill="none" /><path d="M10 6v4l3 2" stroke={C.primary} strokeWidth="1.4" strokeLinecap="round" /></>,
  },
  {
    title: 'Exceptional Trading Conditions',
    desc: 'Ultra-low latency execution, deep liquidity, and competitive spreads across all instruments.',
    icon: <><rect x="3" y="8" width="4" height="9" rx="1" fill="none" stroke={C.tx} strokeWidth="1.3" /><rect x="8" y="5" width="4" height="12" rx="1" fill="none" stroke={C.tx} strokeWidth="1.3" /><rect x="13" y="3" width="4" height="14" rx="1" fill="none" stroke={C.primary} strokeWidth="1.3" /></>,
  },
  {
    title: 'Automated Risk Management',
    desc: 'Real-time risk controls protect your capital while maximizing returns on every trade.',
    icon: <><path d="M10 2l8 4v5c0 4-3.5 7-8 9-4.5-2-8-5-8-9V6l8-4z" stroke={C.tx} strokeWidth="1.3" fill="none" /><path d="M7 10l2 2 4-4" stroke={C.primary} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" /></>,
  },
]

const ECOSYSTEM_RIGHT = [
  {
    title: 'Profit on Every Market Condition',
    desc: 'Arbitrage opportunities exist in bull and bear markets — our engine captures value regardless of direction.',
    icon: <path d="M4 14l4-4 3 3 5-7" stroke={C.primary} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />,
  },
  {
    title: 'Global Exchange Coverage',
    desc: 'Connected to 50+ exchanges worldwide — combining international reach with regional market intelligence.',
    icon: <><circle cx="10" cy="10" r="7" stroke={C.tx} strokeWidth="1.3" fill="none" /><circle cx="10" cy="10" r="3" fill="none" stroke={C.primary} strokeWidth="1.3" /><line x1="10" y1="3" x2="10" y2="5" stroke={C.tx} strokeWidth="1.2" /><line x1="10" y1="15" x2="10" y2="17" stroke={C.tx} strokeWidth="1.2" /><line x1="3" y1="10" x2="5" y2="10" stroke={C.tx} strokeWidth="1.2" /><line x1="15" y1="10" x2="17" y2="10" stroke={C.tx} strokeWidth="1.2" /></>,
  },
  {
    title: 'Instant & Secure Withdrawals',
    desc: 'Prompt and fully protected fund withdrawals through robust systems and transparent processes.',
    icon: <><path d="M10 3v14M5 8l5-5 5 5" stroke={C.tx} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" /><path d="M4 17h12" stroke={C.primary} strokeWidth="1.4" strokeLinecap="round" /></>,
  },
]

const OPPORTUNITIES = [
  { buy: 'KRAKEN', sell: 'COINBASE', pair: 'BTC/USDT', spread: '82.20', pct: '0.12' },
  { buy: 'BINANCE', sell: 'BYBIT', pair: 'ETH/USDT', spread: '3.47', pct: '0.09' },
  { buy: 'OKX', sell: 'BINANCE', pair: 'SOL/USDT', spread: '0.31', pct: '0.21' },
  { buy: 'GATE.IO', sell: 'COINBASE', pair: 'BNB/USDT', spread: '1.82', pct: '0.32' },
]

const SOCIAL_LINKS = [
  {
    label: 'X (Twitter)',
    icon: <path d="M4 4l12 12M16 4L4 16" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />,
  },
  {
    label: 'Telegram',
    icon: <path d="M3 9.8l14-6-2.4 13-4-3.2-2 3-1-4.4-4.6-2.4z" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />,
  },
  {
    label: 'LinkedIn',
    icon: <text x="10" y="14" textAnchor="middle" fontSize="11" fontWeight="800" fill="currentColor" fontFamily="Poppins, sans-serif">in</text>,
  },
  {
    label: 'YouTube',
    icon: <><rect x="2" y="5" width="16" height="10" rx="3" fill="none" stroke="currentColor" strokeWidth="1.3" /><path d="M8.5 7.8l4 2.2-4 2.2V7.8z" fill="currentColor" /></>,
  },
]

const FOOTER_COLS = [
  { title: 'Trading', links: ['Spot Arbitrage', 'Futures Arbitrage', 'Cross-Exchange', 'Smart Trading Bot', 'Pricing & Fees'] },
  { title: 'Resources', links: ['Market Insights', 'Research Library', 'Xperia Academy', 'API Documentation', 'Glossary'] },
  { title: 'Company', links: ['About Us', 'Our Team', 'Regulation & Licences', 'Careers', 'Legal'] },
]

const REG_FLAGS = [
  { country: 'mu', code: 'FSC' },
  { country: 'gb', code: 'FCA' },
  { country: 'ae', code: 'CMA' },
  { country: 'za', code: 'FSCA' },
  { country: 'au', code: 'ASIC' },
  { country: 'nz', code: 'FMA' },
  { country: 'sc', code: 'FSA' },
]

const glass = { background: C.card, borderRadius: '12px' }

function cardBg(image) {
  return {
    backgroundImage: `linear-gradient(100deg, rgba(13,16,25,0.9) 0%, rgba(13,16,25,0.6) 45%, rgba(13,16,25,0.15) 100%), url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }
}

function Divider({ tall }) {
  return <div className="xp2-divider" style={{ background: C.bdr, height: tall ? '72px' : '60px', marginTop: tall ? 0 : '8px' }} />
}

function FlagBadge({ country, size = 44 }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', position: 'relative', overflow: 'hidden', flexShrink: 0,
      boxShadow: '0 4px 8px rgba(0,0,0,0.5), inset 0 -4px 8px rgba(0,0,0,0.45), inset 0 3px 5px rgba(255,255,255,0.3)',
    }}>
      <span className={`fi fi-${country}`} style={{ width: size, height: size, backgroundSize: 'cover', display: 'block' }} />
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: 'radial-gradient(circle at 32% 26%, rgba(255,255,255,0.6), rgba(255,255,255,0) 55%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', boxShadow: 'inset 0 -7px 10px rgba(0,0,0,0.5)', pointerEvents: 'none' }} />
    </div>
  )
}

// Isolated so its 2s/15s price polling and click-driven filtering only re-render
// this subtree, instead of the whole page (hero video, footer, etc.) on every tick/click.
const MarketTicker = React.memo(function MarketTicker() {
  const [activeTab, setActiveTab] = useState('Popular')
  const [liveTicker, setLiveTicker] = useState(null)
  const [hourlyChange, setHourlyChange] = useState({})

  useEffect(() => {
    let cancelled = false
    const symbolsParam = encodeURIComponent(JSON.stringify(BINANCE_SYMBOLS.map(([s]) => s)))
    const fetchTicker = () => {
      fetch(`https://api.binance.com/api/v3/ticker/24hr?symbols=${symbolsParam}`)
        .then(res => (res.ok ? res.json() : Promise.reject(new Error('bad response'))))
        .then(data => {
          if (cancelled || !Array.isArray(data)) return
          const bySymbol = Object.fromEntries(data.map(d => [d.symbol, d]))
          const next = BINANCE_SYMBOLS.map(([symbol, pair]) => {
            const d = bySymbol[symbol]
            if (!d) return null
            const pct = Number(d.priceChangePercent)
            return {
              pair,
              price: formatPrice(d.lastPrice),
              pct: Math.abs(pct).toFixed(2),
              up: pct >= 0,
              volume: formatVolume(d.quoteVolume),
            }
          }).filter(Boolean)
          if (next.length) setLiveTicker(next)
        })
        .catch(() => {})
    }
    fetchTicker()
    const id = setInterval(fetchTicker, 2000)
    return () => { cancelled = true; clearInterval(id) }
  }, [])

  useEffect(() => {
    let cancelled = false
    const symbolsParam = encodeURIComponent(JSON.stringify(BINANCE_SYMBOLS.map(([s]) => s)))
    const fetchHourly = () => {
      fetch(`https://api.binance.com/api/v3/ticker?symbols=${symbolsParam}&windowSize=1h`)
        .then(res => (res.ok ? res.json() : Promise.reject(new Error('bad response'))))
        .then(data => {
          if (cancelled || !Array.isArray(data)) return
          const next = {}
          for (const d of data) {
            const entry = BINANCE_SYMBOLS.find(([symbol]) => symbol === d.symbol)
            if (!entry) continue
            const pct = Number(d.priceChangePercent)
            next[entry[1]] = { pct: Math.abs(pct).toFixed(2), up: pct >= 0 }
          }
          if (Object.keys(next).length) setHourlyChange(next)
        })
        .catch(() => {})
    }
    fetchHourly()
    const id = setInterval(fetchHourly, 15000)
    return () => { cancelled = true; clearInterval(id) }
  }, [])

  const allTickerPairs = liveTicker && liveTicker.length ? liveTicker : MARKET_PAIRS
  const allowedPairs = CATEGORY_PAIRS[activeTab]
  const tickerSource = allowedPairs ? allTickerPairs.filter(t => allowedPairs.includes(t.pair)) : allTickerPairs
  const tickerHalfRepeat = tickerSource.length ? Math.max(1, Math.ceil(12 / tickerSource.length)) : 0
  const tickerRepeat = tickerHalfRepeat * 2
  const tickerPairs = tickerSource.length ? Array(tickerRepeat).fill(tickerSource).flat() : []
  const tickerDuration = 90 * (tickerRepeat / 4)

  return (
    <div style={{ background: C.dark2, borderBottom: `1px solid ${C.dbdr}` }}>
      <div className="xp2-tabs-desktop" style={{ maxWidth: '1320px', margin: '0 auto', padding: '0 40px', display: 'flex', justifyContent: 'center', gap: 0, borderBottom: `1px solid ${C.dbdr}`, overflowX: 'auto' }}>
        {CATEGORY_TABS.map(tab => (
          <div key={tab} onClick={() => setActiveTab(tab)} className="xp2-tab" style={{
            fontSize: '12px', fontWeight: tab === activeTab ? 600 : 400,
            color: tab === activeTab ? C.primary : C.ltx3,
            padding: '12px 20px', borderBottom: tab === activeTab ? `2px solid ${C.primary}` : '2px solid transparent',
            cursor: 'pointer', whiteSpace: 'nowrap', transition: 'color 0.2s',
          }}>{tab}</div>
        ))}
      </div>
      <div className="xp2-tabs-mobile" style={{ padding: '10px 16px', borderBottom: `1px solid ${C.dbdr}` }}>
        <select
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
          style={{
            width: '100%', background: C.dark2, color: C.primary, fontWeight: 600, fontSize: '13px',
            border: `1px solid ${C.dbdr}`, borderRadius: '8px', padding: '10px 12px', fontFamily: fBody,
          }}
        >
          {CATEGORY_TABS.map(tab => <option key={tab} value={tab}>{tab}</option>)}
        </select>
      </div>
      <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', padding: '12px 0', borderBottom: `1px solid ${C.dbdr}` }}>
        <div key={activeTab} className="xp2-ticker-track" style={{ display: 'inline-flex', alignItems: 'center', gap: 0, animationDuration: `${tickerDuration}s` }}>
          {tickerPairs.map(({ pair, volume, price, pct, up }, i) => {
            const hourly = hourlyChange[pair]
            return (
              <div key={i} style={{ display: 'inline-flex', alignItems: 'center', padding: '0 32px', borderRight: `1px solid ${C.dbdr}`, gap: '14px', flexShrink: 0 }}>
                <div>
                  <div style={{ fontFamily: fMono, fontSize: '14px', fontWeight: 700, color: C.ltx }}>{pair}</div>
                  <div style={{ fontSize: '11px', color: C.ltx3, marginTop: '2px' }}>VOL: {volume}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '14px', color: up ? C.up : C.down, fontFamily: fMono }}>{price}</div>
                  <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '2px', fontFamily: fMono }}>
                    <span style={{ fontSize: '10px', color: hourly ? (hourly.up ? C.up : C.down) : C.ltx3 }}>
                      1H {hourly ? `${hourly.up ? '▲' : '▼'}${hourly.pct}%` : '···'}
                    </span>
                    <span style={{ fontSize: '10px', color: up ? C.up : C.down }}>24H {up ? '▲' : '▼'}{pct}%</span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div style={{ maxWidth: '1320px', margin: '0 auto', padding: '10px 40px', textAlign: 'center' }}>
        <span style={{ fontSize: '10px', color: C.ltx3, fontFamily: fMono }}>
          {liveTicker && liveTicker.length ? 'Live prices via Binance · Refreshed every 2s' : 'Connecting to live prices…'} · Not investment advice
        </span>
      </div>
    </div>
  )
})

// Isolated so its 3s counter tick doesn't re-render the rest of the page.
const TradeCountStat = React.memo(function TradeCountStat() {
  const [tradeCount, setTradeCount] = useState(923847)
  useEffect(() => {
    const id = setInterval(() => {
      setTradeCount(c => c + Math.floor(Math.random() * 3 + 1))
    }, 3000)
    return () => clearInterval(id)
  }, [])
  return <>{tradeCount.toLocaleString()}+</>
})

// Isolated so its 3s opportunity rotation doesn't re-render the rest of the page.
const LiveScannerPhone = React.memo(function LiveScannerPhone() {
  const [oppIndex, setOppIndex] = useState(0)
  useEffect(() => {
    const id = setInterval(() => {
      setOppIndex(i => (i + 1) % OPPORTUNITIES.length)
    }, 3000)
    return () => clearInterval(id)
  }, [])
  const opp = OPPORTUNITIES[oppIndex]
  return (
    <div style={{ width: '260px', height: '500px', background: C.dark2, border: '1px solid rgba(255,255,255,0.1)', borderRadius: '36px', padding: '14px', boxShadow: '0 40px 80px rgba(0,0,0,0.25)' }}>
      <div style={{ width: '70px', height: '5px', background: 'rgba(255,255,255,0.12)', borderRadius: '3px', margin: '0 auto 12px' }} />
      <div style={{ background: C.dark, borderRadius: '24px', height: 'calc(100% - 28px)', padding: '18px 14px', overflow: 'hidden', position: 'relative' }}>
        <div style={{ fontFamily: fMono, fontSize: '9px', color: C.ltx2, marginBottom: '4px', letterSpacing: '0.08em' }}>LIVE SCANNER</div>
        <div style={{ fontSize: '7px', color: C.ltx3, fontFamily: fMono, marginBottom: '10px' }}>50 EXCHANGES · BTC/USDT</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginBottom: '12px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '70px 1fr 50px', fontFamily: fMono, fontSize: '7px', background: 'rgba(0,187,118,0.1)', borderLeft: `1.5px solid ${C.up}`, padding: '5px 7px', borderRadius: '2px' }}>
            <span style={{ color: C.up }}>COINBASE</span><span style={{ color: C.up, textAlign: 'right' }}>67,341.20</span><span style={{ color: C.up, textAlign: 'right' }}>+56.70</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '70px 1fr 50px', fontFamily: fMono, fontSize: '7px', padding: '5px 7px', color: C.ltx2 }}>
            <span>BINANCE</span><span style={{ textAlign: 'right' }}>67,284.50</span><span style={{ textAlign: 'right', color: C.ltx3 }}>BASE</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '70px 1fr 50px', fontFamily: fMono, fontSize: '7px', padding: '5px 7px', color: C.ltx2 }}>
            <span>KRAKEN</span><span style={{ textAlign: 'right' }}>67,259.00</span><span style={{ textAlign: 'right', color: C.down }}>−25.50</span>
          </div>
        </div>
        <div style={{ background: 'rgba(0,187,118,0.08)', border: '1px solid rgba(0,187,118,0.25)', borderRadius: '6px', padding: '10px', marginBottom: '12px' }}>
          <div style={{ fontFamily: fMono, fontSize: '7px', color: C.up, marginBottom: '5px' }}>⚡ EXECUTING TRADE...</div>
          <div style={{ fontFamily: fMono, fontSize: '8px', color: C.ltx, marginBottom: '4px' }}>BUY {opp.buy} → SELL {opp.sell}</div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <div><div style={{ fontSize: '6px', color: C.ltx3 }}>SPREAD</div><div style={{ fontSize: '10px', color: C.up, fontFamily: fMono }}>${opp.spread}</div></div>
            <div><div style={{ fontSize: '6px', color: C.ltx3 }}>PROFIT</div><div style={{ fontSize: '10px', color: C.up, fontFamily: fMono }}>{opp.pct}%</div></div>
          </div>
        </div>
        <div style={{ position: 'absolute', bottom: '14px', left: '14px', right: '14px', background: 'rgba(0,187,118,0.12)', borderRadius: '5px', padding: '7px 10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <div className="xp2-live-dot" style={{ width: '5px', height: '5px', borderRadius: '50%', background: C.up }} />
          <span style={{ fontFamily: fMono, fontSize: '7px', color: C.up }}>BOT ACTIVE</span>
        </div>
      </div>
    </div>
  )
})

export default function Home() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [heroTier, setHeroTier] = useState(() => getHeroTier(window.innerWidth))
  const [isMobileNav, setIsMobileNav] = useState(() => window.innerWidth <= 900)
  const heroVideoRef = React.useRef(null)
  const year = new Date().getFullYear()

  useEffect(() => {
    const v = heroVideoRef.current
    if (v) { v.play().catch(() => {}) }
  }, [heroTier])

  useEffect(() => {
    const onResize = () => {
      const width = window.innerWidth
      setHeroTier(t => {
        const next = getHeroTier(width)
        return next === t ? t : next
      })
      const nextMobile = width <= 900
      setIsMobileNav(m => {
        if (m && !nextMobile) setMobileOpen(false)
        return nextMobile === m ? m : nextMobile
      })
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const partnerLoop = [...PARTNERS, ...PARTNERS, ...PARTNERS, ...PARTNERS]

  return (
    <div className="xp2" style={{ background: C.white, color: C.tx }}>
      <style>{styles}</style>

      {/* MAIN NAV */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: 'rgba(10,10,11,0.55)', backdropFilter: 'blur(20px) saturate(160%)', WebkitBackdropFilter: 'blur(20px) saturate(160%)', borderBottom: `1px solid ${C.dbdr}` }}>
        <div className="xp2-nav-inner" style={{ maxWidth: '1320px', margin: '0 auto', padding: '0 40px', display: 'flex', alignItems: 'center', height: '60px', gap: '48px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
            <LogoMark size={38} />
            <Wordmark size={17} />
          </div>
          <div className="xp2-navlinks" style={{ display: 'flex', gap: '28px', flex: 1, alignItems: 'center' }}>
            {NAV_LINKS.map(({ label, href }) => {
              if (label === 'Trading') {
                return <NavDropdown key={label} label="Trading" active={null} menu={TRADING_MENU} linkTrigger={false} />
              }
              if (label === 'Resources') {
                return <NavDropdown key={label} label="Resources" to="/resources" active={null} menu={RESOURCES_MENU} linkTrigger={true} />
              }
              if (label === 'Company') {
                return <NavDropdown key={label} label="Company" to="/company" active={null} menu={COMPANY_MENU} linkTrigger={true} />
              }
              return <a key={label} href={href} className="xp2-navlink" style={{ fontSize: '13px', color: label === 'Home' ? C.primary : C.ltx2, fontWeight: label === 'Home' ? 500 : 400, transition: 'color 0.2s' }}>{label}</a>
            })}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
            <Link to="/login" className="xp2-cta" style={{ fontSize: '13px', fontWeight: 600, background: C.primary, color: C.dark, padding: '9px 20px', borderRadius: '999px', transition: 'background 0.2s' }}>Log In</Link>
            {isMobileNav && (
              <button
                aria-label="Toggle menu"
                onClick={() => setMobileOpen(o => !o)}
                style={{ width: '28px', height: '18px', display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
              >
                <div style={{ width: '100%', height: '2px', background: C.ltx2, borderRadius: '1px' }} />
                <div style={{ width: mobileOpen ? '100%' : '70%', height: '2px', background: C.ltx3, borderRadius: '1px' }} />
              </button>
            )}
          </div>
        </div>

        {isMobileNav && mobileOpen && (
          <div style={{ borderTop: `1px solid ${C.dbdr}`, padding: '16px 24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {NAV_LINKS.map(({ label, href }) => {
              if (label === 'Trading') {
                return (
                  <div key={label}>
                    <div style={{ fontSize: '14px', color: C.ltx, fontWeight: 600, marginBottom: '10px' }}>Trading</div>
                    {TRADING_MENU.map(col => (
                      <div key={col.title} style={{ marginBottom: '12px' }}>
                        <div style={{ fontSize: '11px', color: C.ltx3, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '8px' }}>{col.title}</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {col.links.map(l => (
                            <a key={l.label} href={l.to} onClick={() => setMobileOpen(false)} style={{ fontSize: '13px', color: C.ltx2 }}>{l.label}</a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
              if (label === 'Resources') {
                return (
                  <div key={label}>
                    <a href="/resources" onClick={() => setMobileOpen(false)} style={{ display: 'block', fontSize: '14px', color: C.ltx, fontWeight: 600, marginBottom: '10px', textDecoration: 'none' }}>Resources</a>
                    {RESOURCES_MENU.map(col => (
                      <div key={col.title} style={{ marginBottom: '12px' }}>
                        <div style={{ fontSize: '11px', color: C.ltx3, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '8px' }}>{col.title}</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {col.links.map(l => (
                            <a key={l.label} href={l.to} onClick={() => setMobileOpen(false)} style={{ fontSize: '13px', color: C.ltx2 }}>{l.label}</a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
              if (label === 'Company') {
                return (
                  <div key={label}>
                    <a href="/company" onClick={() => setMobileOpen(false)} style={{ display: 'block', fontSize: '14px', color: C.ltx, fontWeight: 600, marginBottom: '10px', textDecoration: 'none' }}>Company</a>
                    {COMPANY_MENU.map(col => (
                      <div key={col.title} style={{ marginBottom: '12px' }}>
                        <div style={{ fontSize: '11px', color: C.ltx3, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '8px' }}>{col.title}</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {col.links.map(l => (
                            <a key={l.label} href={l.to} onClick={() => setMobileOpen(false)} style={{ fontSize: '13px', color: C.ltx2 }}>{l.label}</a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
              return <a key={label} href={href} onClick={() => setMobileOpen(false)} style={{ fontSize: '14px', color: C.ltx2 }}>{label}</a>
            })}
            <div style={{ display: 'flex', gap: '10px', marginTop: '4px' }}>
              <Link to="/login" style={{ flex: 1, textAlign: 'center', fontSize: '13px', fontWeight: 600, background: C.primary, color: C.dark, padding: '10px 0', borderRadius: '999px' }}>Log In</Link>
            </div>
          </div>
        )}
      </nav>

      {/* HERO */}
      <section id="xp2-top" className="xp2-hero" style={{ position: 'relative', minHeight: '82vh', paddingTop: '60px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: C.dark, zIndex: 0 }}>
          <video
            key={heroTier}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="xp2-hero-video"
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
          >
            <source src={HERO_VIDEOS[heroTier]} type="video/webm" />
          </video>
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.62)' }} />
          <span style={{ position: 'absolute', top: '14%', left: '6%', fontFamily: fMono, fontSize: '20px', fontWeight: 700, color: 'rgba(255,255,255,0.22)' }}>+30.40%</span>
          <span style={{ position: 'absolute', top: '24%', left: '11%', fontFamily: fMono, fontSize: '14px', color: 'rgba(255,255,255,0.15)' }}>+17.40%</span>
          <span style={{ position: 'absolute', top: '36%', left: '5%', fontFamily: fMono, fontSize: '13px', color: 'rgba(255,255,255,0.12)' }}>+1.70%</span>
          <span style={{ position: 'absolute', top: '48%', left: '9%', fontFamily: fMono, fontSize: '16px', color: 'rgba(255,255,255,0.14)' }}>+0.35%</span>
          <span style={{ position: 'absolute', top: '64%', left: '6%', fontFamily: fMono, fontSize: '15px', color: 'rgba(200,80,80,0.5)' }}>−3.90%</span>
          <span style={{ position: 'absolute', top: '72%', left: '12%', fontFamily: fMono, fontSize: '13px', color: 'rgba(200,80,80,0.4)' }}>−1.80%</span>
          <span style={{ position: 'absolute', top: '10%', right: '8%', fontFamily: fMono, fontSize: '22px', fontWeight: 700, color: 'rgba(255,255,255,0.22)' }}>+60.80%</span>
          <span style={{ position: 'absolute', top: '22%', right: '5%', fontFamily: fMono, fontSize: '15px', color: 'rgba(255,255,255,0.16)' }}>+8.30%</span>
          <span style={{ position: 'absolute', top: '38%', right: '9%', fontFamily: fMono, fontSize: '13px', color: 'rgba(255,255,255,0.12)' }}>+1.71%</span>
          <span style={{ position: 'absolute', top: '50%', right: '6%', fontFamily: fMono, fontSize: '16px', color: 'rgba(255,255,255,0.14)' }}>+1.70%</span>
          <span style={{ position: 'absolute', top: '65%', right: '7%', fontFamily: fMono, fontSize: '26px', fontWeight: 700, color: 'rgba(200,80,80,0.35)' }}>−70.25%</span>
          <span style={{ position: 'absolute', top: '76%', right: '5%', fontFamily: fMono, fontSize: '15px', color: 'rgba(200,80,80,0.3)' }}>−20.17%</span>
        </div>

        <div className="xp2-hero-content" style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: '720px', padding: '0 32px' }}>
          <h1 className="xp2-hero-title" style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(38px,5.5vw,68px)', lineHeight: 1.1, color: C.ltx, marginBottom: '28px', letterSpacing: '-0.02em' }}>
            Trade With The Smartest<br />Crypto Arbitrage Platform
          </h1>
          <Link to="/login" className="xp2-cta" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '15px', padding: '14px 36px', borderRadius: '999px', letterSpacing: '0.01em', transition: 'background 0.2s', marginBottom: '20px' }}>
            Start Trading
          </Link>
          <p style={{ fontSize: '11px', color: C.ltx3 }}>Trading involves risk. Please ensure you understand the risks involved.</p>
        </div>
      </section>

      {/* MARKET TICKER BAR */}
      <MarketTicker />

      {/* ULTIMATE ARBITRAGE EXPERIENCE */}
      <section style={{ padding: '80px 40px', textAlign: 'center' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,3.5vw,42px)', letterSpacing: '-0.02em', marginBottom: '16px' }}>The Ultimate Arbitrage Experience</h2>
          <p style={{ fontSize: '15px', color: C.tx2, lineHeight: 1.75, maxWidth: '560px', margin: '0 auto 52px' }}>
            With cutting-edge AI technology and 50+ exchange integrations, Xperia Capital empowers your trading journey through automation, precision, and transparency.
          </p>
          <div className="xp2-grid-stats3" style={{ display: 'grid', gridTemplateColumns: '1fr 1px 1fr 1px 1fr', gap: 0, alignItems: 'start' }}>
            <div style={{ padding: '0 40px' }}>
              <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,3vw,40px)', marginBottom: '8px' }}>0.004 <span style={{ fontSize: '0.6em', fontWeight: 600 }}>sec</span></div>
              <div style={{ fontSize: '12px', color: C.tx3, lineHeight: 1.5 }}>Lightning-Fast Order<br />Execution</div>
            </div>
            <Divider />
            <div style={{ padding: '0 40px' }}>
              <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,3vw,40px)', marginBottom: '8px' }}>99.9<span style={{ fontSize: '0.6em', fontWeight: 600 }}>%</span></div>
              <div style={{ fontSize: '12px', color: C.tx3, lineHeight: 1.5 }}>Platform Uptime<br />Guaranteed</div>
            </div>
            <Divider />
            <div style={{ padding: '0 40px' }}>
              <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,3vw,40px)', marginBottom: '8px' }}>50<span style={{ fontSize: '0.6em', fontWeight: 600 }}>+</span></div>
              <div style={{ fontSize: '12px', color: C.tx3, lineHeight: 1.5 }}>Global Exchanges<br />Connected</div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY TRADERS CHOOSE */}
      <section id="xp2-resources" style={{ padding: '20px 40px 80px' }}>
        <div style={{ maxWidth: '1320px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '44px' }}>
            <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3vw,40px)', letterSpacing: '-0.02em', marginBottom: '12px' }}>Why Traders Choose Xperia Capital</h2>
            <p style={{ fontSize: '14px', color: C.tx2 }}>Here's what makes Xperia Capital the top choice for arbitrage traders.</p>
          </div>
          <div className="xp2-grid-why" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            {/* App card */}
            <div style={{ ...glass, ...cardBg('/assets/images/cards/app-card-bg.webp'), overflow: 'hidden', padding: '32px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '420px' }}>
              <div>
                <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: '18px', color: C.ltx, marginBottom: '8px' }}>Xperia Capital App</div>
                <p style={{ fontSize: '13px', color: C.ltx2, lineHeight: 1.6, maxWidth: '300px' }}>The power of Xperia Capital in your pocket — fast, secure, and built for traders on the move.</p>
              </div>
              <a href="#" className="xp2-linklike" style={{ fontSize: '13px', color: C.primary, fontWeight: 600, display: 'flex', alignItems: 'center', gap: '6px', transition: 'gap 0.2s' }}>Download the App →</a>
            </div>

            {/* Right column */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ ...glass, ...cardBg('/assets/images/cards/market-analysis-bg.webp'), overflow: 'hidden', padding: '32px', flex: 1, minHeight: '200px', position: 'relative' }}>
                <div style={{ position: 'relative' }}>
                  <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: '18px', color: C.ltx, marginBottom: '8px' }}>Live Market Analysis</div>
                  <p style={{ fontSize: '13px', color: C.ltx2, lineHeight: 1.6, maxWidth: '280px' }}>Real-time arbitrage opportunities and spread analysis across global crypto markets.</p>
                </div>
                <a href="#" className="xp2-linklike" style={{ fontSize: '13px', color: C.primary, fontWeight: 600, display: 'flex', alignItems: 'center', gap: '6px', marginTop: '80px', position: 'relative', transition: 'gap 0.2s' }}>View Live Scanner →</a>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div style={{ ...glass, ...cardBg('/assets/images/cards/security-bg.webp'), padding: '28px', minHeight: '160px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: '14px', color: C.ltx, marginBottom: '6px' }}>Security &amp; Compliance</div>
                    <p style={{ fontSize: '12px', color: C.ltx2, lineHeight: 1.5 }}>Secured by enterprise-grade encryption and globally compliant standards.</p>
                  </div>
                  <a href="#" style={{ fontSize: '12px', color: C.primary, fontWeight: 600, marginTop: '12px' }}>View Licences →</a>
                </div>
                <div style={{ ...glass, ...cardBg('/assets/images/cards/market-insights-bg.webp'), padding: '28px', minHeight: '160px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: '14px', color: C.ltx, marginBottom: '6px' }}>Market Insights</div>
                    <p style={{ fontSize: '12px', color: C.ltx2, lineHeight: 1.5 }}>Expert arbitrage analysis and strategy guides covering all major crypto developments.</p>
                  </div>
                  <a href="#" style={{ fontSize: '12px', color: C.primary, fontWeight: 600, marginTop: '12px' }}>Start Learning →</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BY THE NUMBERS */}
      <section style={{ padding: '60px 40px 80px', borderTop: `1px solid ${C.bdr}` }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3vw,40px)', letterSpacing: '-0.02em', marginBottom: '12px' }}>Xperia Capital by the Numbers</h2>
          <p style={{ fontSize: '14px', color: C.tx2, marginBottom: '52px' }}>Xperia Capital empowers thousands of traders across the globe.</p>
          <div className="xp2-grid-stats3" style={{ display: 'grid', gridTemplateColumns: '1fr 1px 1fr 1px 1fr', gap: 0, alignItems: 'center', marginBottom: '40px' }}>
            <div style={{ padding: '0 32px' }}>
              <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,4vw,52px)', letterSpacing: '-0.03em', marginBottom: '8px' }}>$48.51B</div>
              <div style={{ fontSize: '13px', color: C.tx2 }}>Avg. Monthly Trading Volume</div>
            </div>
            <Divider tall />
            <div style={{ padding: '0 32px' }}>
              <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,4vw,52px)', letterSpacing: '-0.03em', marginBottom: '8px' }}><TradeCountStat /></div>
              <div style={{ fontSize: '13px', color: C.tx2 }}>Total Arbitrage Trades</div>
            </div>
            <Divider tall />
            <div style={{ padding: '0 32px' }}>
              <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,4vw,52px)', letterSpacing: '-0.03em', marginBottom: '8px' }}>99.9%</div>
              <div style={{ fontSize: '13px', color: C.tx2 }}>Platform Uptime SLA</div>
            </div>
          </div>
          <p style={{ fontSize: '11px', color: C.tx3, marginBottom: '24px' }}>*Data as of {year}</p>
          <a href="#xp2-company" className="xp2-cta" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '14px', padding: '13px 32px', borderRadius: '999px', transition: 'background 0.2s' }}>Learn More About Xperia Capital</a>
        </div>
      </section>

      {/* DISCOVER TRADING ECOSYSTEM */}
      <section id="xp2-trading" style={{ padding: '80px 40px', borderTop: `1px solid ${C.bdr}` }}>
        <div style={{ maxWidth: '1320px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '56px' }}>
            <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3vw,40px)', letterSpacing: '-0.02em', marginBottom: '12px' }}>Discover A Dynamic Trading Ecosystem</h2>
            <p style={{ fontSize: '14px', color: C.tx2, maxWidth: '560px', margin: '0 auto' }}>Trade BTC, ETH, DeFi tokens, and indices with confidence — Xperia Capital delivers precision, automation, and profitability.</p>
          </div>
          <div className="xp2-grid-eco" style={{ display: 'grid', gridTemplateColumns: '1fr 360px 1fr', gap: '48px', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '36px' }}>
              {ECOSYSTEM_LEFT.map(({ title, desc, icon }) => (
                <div key={title} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{ width: '40px', height: '40px', border: `1.5px solid ${C.bdr}`, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: C.light }}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">{icon}</svg>
                  </div>
                  <div>
                    <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: '14px', marginBottom: '5px' }}>{title}</div>
                    <p style={{ fontSize: '13px', color: C.tx2, lineHeight: 1.6 }}>{desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="xp2-grid-eco-phone" style={{ display: 'flex', justifyContent: 'center' }}>
              <LiveScannerPhone />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '36px' }}>
              {ECOSYSTEM_RIGHT.map(({ title, desc, icon }) => (
                <div key={title} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{ width: '40px', height: '40px', border: `1.5px solid ${C.bdr}`, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: C.light }}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">{icon}</svg>
                  </div>
                  <div>
                    <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: '14px', marginBottom: '5px' }}>{title}</div>
                    <p style={{ fontSize: '13px', color: C.tx2, lineHeight: 1.6 }}>{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PARTNER LOGOS TICKER */}
      <div id="xp2-partner" style={{ background: C.light, borderTop: `1px solid ${C.bdr}`, borderBottom: `1px solid ${C.bdr}`, overflow: 'hidden', padding: '20px 0' }}>
        <div className="xp2-partner-track" style={{ display: 'inline-flex', gap: 0, whiteSpace: 'nowrap' }}>
          {partnerLoop.map((name, i) => (
            <React.Fragment key={i}>
              <span style={{ fontFamily: fMono, fontSize: '11px', color: C.tx3, letterSpacing: '0.12em', padding: '0 44px' }}>{name}</span>
              <span style={{ color: C.bdr, padding: '0 2px' }}>·</span>
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* FOOTER */}
      <footer id="xp2-company" style={{ background: C.dark, borderTop: `1px solid ${C.dbdr}` }}>
        <div style={{ maxWidth: '1320px', margin: '0 auto', padding: '60px 40px' }}>
          <div className="xp2-footer-bottom" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', marginBottom: '56px' }}>
            <div>
              <h3 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: '26px', color: C.ltx, marginBottom: '24px', lineHeight: 1.2 }}>The Ultimate<br />Trading Experience</h3>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                {REG_FLAGS.map(({ country, code }) => (
                  <div key={code} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
                    <FlagBadge country={country} />
                    <span style={{ fontSize: '10px', color: C.ltx3, fontWeight: 600, letterSpacing: '0.04em' }}>{code}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div style={{ fontSize: '11px', fontWeight: 700, color: C.ltx2, marginBottom: '8px', letterSpacing: '0.06em' }}>DISCLAIMER</div>
              <p style={{ fontSize: '11px', color: C.ltx3, lineHeight: 1.75, marginBottom: '10px' }}>The information provided on this website is not intended for residents of the UK, EU, US, or any other jurisdiction where its distribution or use may violate local laws, regulations, or sanctions.</p>
              <p style={{ fontSize: '11px', color: C.ltx3, lineHeight: 1.75, marginBottom: '10px' }}>
                The content on this website has been prepared without considering the specific objectives, financial situation, or needs of any individual. Therefore, it is important that the information be evaluated in light of the relevant circumstances. It is strongly recommended to review the applicable documents available on the Xperia Capital legal page, which includes the <a href="#" style={{ color: C.ltx2, textDecoration: 'underline' }}>Client Agreement</a>, <a href="#" style={{ color: C.ltx2, textDecoration: 'underline' }}>Risk Disclosure</a>, Key Information Documents, and other important materials.
              </p>
              <p style={{ fontSize: '11px', color: C.ltx3, lineHeight: 1.75, marginBottom: '16px' }}>Apple, iPad, and iPhone are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc. Android is a trademark of Google Inc.</p>
              <div style={{ fontSize: '11px', fontWeight: 700, color: C.ltx2, marginBottom: '8px', letterSpacing: '0.06em' }}>RISK DISCLOSURE</div>
              <p style={{ fontSize: '11px', color: C.ltx3, lineHeight: 1.75 }}>Trading involves a high level of risk and may result in losses exceeding the initial deposit. Contracts for Difference (CFDs) are complex instruments and may not be suitable for all investors. Trading with leverage amplifies risks, and it is crucial to assess risk tolerance before engaging in trading. It is essential to evaluate whether the potential to lose more than the initial investment is financially sustainable. Trade responsibly. For more information, please visit our <a href="#" style={{ color: C.ltx2, textDecoration: 'underline' }}>legal page</a>.</p>
            </div>
          </div>

          <div className="xp2-footer-top" style={{ borderTop: `1px solid ${C.dbdr}`, paddingTop: '40px', display: 'grid', gridTemplateColumns: '280px 1fr 1fr 1fr', gap: '60px' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '9px', marginBottom: '16px' }}>
                <LogoMark size={26} />
                <Wordmark size={14} />
              </div>
              <p style={{ fontSize: '13px', color: C.ltx2, lineHeight: 1.75, marginBottom: '24px' }}>Automated crypto arbitrage for the modern trader. 50+ exchanges, zero effort, consistent returns.</p>
              <div style={{ background: C.dark3, border: `1px solid ${C.dbdr}`, borderRadius: '8px', padding: '16px', textAlign: 'center' }}>
                <div style={{ fontSize: '10px', color: C.ltx3, letterSpacing: '0.1em', fontFamily: fMono, marginBottom: '10px' }}>[ SOCIAL MEDIA ]</div>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  {SOCIAL_LINKS.map(({ label, icon }) => (
                    <a key={label} href="#" aria-label={label} className="xp2-social" style={{ width: '32px', height: '32px', border: '1px solid rgba(255,255,255,0.18)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.ltx2, transition: 'color 0.2s, border-color 0.2s, background 0.2s' }}>
                      <svg width="18" height="18" viewBox="0 0 20 20">{icon}</svg>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            {FOOTER_COLS.map(({ title, links }) => (
              <div key={title}>
                <div style={{ fontSize: '11px', color: C.ltx3, letterSpacing: '0.12em', fontFamily: fMono, marginBottom: '20px', textTransform: 'uppercase' }}>{title}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {links.map(l => (
                    <a key={l} href="#" className="xp2-footerlink" style={{ fontSize: '13px', color: C.ltx2, transition: 'color 0.2s' }}>{l}</a>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div style={{ borderTop: `1px solid ${C.dbdr}`, marginTop: '40px', paddingTop: '32px' }}>
            <p style={{ fontSize: '13px', color: C.ltx3 }}>This website is operated by Xperia Capital Limited (Mauritius)</p>
          </div>
        </div>
        <div style={{ borderTop: `1px solid ${C.dbdr}`, padding: '16px 40px' }}>
          <div style={{ maxWidth: '1320px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
            <span style={{ fontSize: '12px', color: C.ltx3 }}>© {year} Xperia Capital. All rights reserved.</span>
            <span style={{ fontSize: '11px', color: C.ltx3, fontFamily: fMono }}>Trading involves risk · Not financial advice</span>
          </div>
        </div>
      </footer>
    </div>
  )
}
